import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import { testSyllabusDetailIF } from "Pages/MyBatchTestSyllabus/MyBatchTestSyllabus";
import CourseSubjectListing from "Pages/MyBatches/MyBatch/SharedComponents/CourseSubjectListing";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import "./index.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";
interface MyBatchTestSyllabusFilter {
  testDetail: any;
  testId: string;
  testSyllabusDetail: testSyllabusDetailIF[];
  selectedCourseSyllabus: any;
  testSyllabusStatus: any;
  setselectedCouseSyllabus: any;
  batchName?: any;
}
const MyBatchTestSyllabusFilter = ({
  testDetail,
  selectedCourseSyllabus,
  testSyllabusStatus,
  setselectedCouseSyllabus,
  batchName,
}: MyBatchTestSyllabusFilter) => {
  const navigate = useNavigate();
  const { screen }: any = useWindowSize();
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM YY")}</div>;
  };
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? "MyBatchTestSyllabusFilter"
          : "MyBatchTestSyllabusFilterMB"
      }
    >
      {["xxl", "xl", "lg"].includes(screen) && (
        <div className="d-flex align-items-center">
          <LeftArrow
            className={"cursorHoverCSS mr-2"}
            onClick={() => {
              navigate(-1);
            }}
          />
          <Typography
            variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
            color="black"
          >
            <div className="d-flex gap-2">
              {testDetail?.type} {"   |   "} {batchName}
            </div>
            <div className="testDetailSpan">
              {"Test Date: "}&nbsp;
              {testDetail.startDate && renderingTime(testDetail.startDate)}-
              {testDetail.endDate && renderingTime(testDetail.endDate)}
            </div>
          </Typography>
        </div>
      )}
      <div className="d-flex justify-content-end">
        <CourseSubjectListing
          item={testSyllabusStatus ? testSyllabusStatus : []}
          selectedCourseSyllabus={selectedCourseSyllabus}
          selectedCourseSyllabusHandler={(item: any) => {
            console.log("itemitem", item);
            setselectedCouseSyllabus(item);
          }}
        ></CourseSubjectListing>
      </div>
    </div>
  );
};
export default MyBatchTestSyllabusFilter;
